import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

function FixedElementsPortal({ children }) {
  const [container] = useState(() => document.createElement('div'));

  useEffect(() => {
    const portalRoot = document.getElementById('portal-root-for-fixed-el');

    portalRoot.appendChild(container);
    container.classList.add('container-960');

    if (portalRoot.childElementCount > 1) {
      // hiding previous child so that only one is shown
      portalRoot.firstChild.classList.add('hidden-mobile-portal-el');
    }

    return () => {
      if (portalRoot.contains(container)) {
        portalRoot.removeChild(container);
        // shawing again previous child if second one was removed
        if (
          portalRoot.childElementCount === 1 &&
          portalRoot.firstChild.classList.contains('hidden-mobile-portal-el')
        ) {
          portalRoot.firstChild.classList.remove('hidden-mobile-portal-el');
        }
      }
    };
  }, [container]);

  return ReactDOM.createPortal(children, container);
}

export default FixedElementsPortal;
